import Payment from './payment';
import Mixpanel from './analytics/mixpanel';
import { isMixpanelEnabled } from './analytics/mixpanelUtils';

const CURRENCY = 'SGD';

const App = (() => {
  const getPaymentData = () => {
    const urlParams = new URLSearchParams(window.location.search);

    return {
      planName: urlParams.get('plan') || '',
      planPrice: urlParams.get('price') || 0,
      redirectUrl: urlParams.get('redirectUrl') || '',
      sessionId: urlParams.get('sessionId') || '',
      sessionData: urlParams.get('sessionData') || '',
      ssoId: urlParams.get('ssoId') || ''
    };
  };

  const displayPlanInfo = ({ planName, planPrice }) => {
    const planNameEl = document.getElementById('planName');
    if (planNameEl && planName) planNameEl.textContent = planName;

    const planPriceEl = document.getElementById('planPrice');
    if (planPriceEl && planPrice) planPriceEl.textContent = `${CURRENCY} ${parseFloat(planPrice).toFixed(2)}`;
  };

  return {
    init: () => {
      const { planName, planPrice, redirectUrl, sessionData, sessionId, ssoId } = getPaymentData();

      // Mixpanel
		  isMixpanelEnabled() && Mixpanel.initMixpanel(ssoId);

      displayPlanInfo({ planName, planPrice });

      Payment.init({
        currency: CURRENCY,
        planPrice,
        redirectUrl,
        sessionData,
        sessionId,
      });
    },
  };
})();

App.init();
